export const PlanTerms = Object.freeze({
  MONTHLY: 0,
  YEARLY: 1,
});

export const Terms = Object.freeze({
  MONTHLY: "monthly",
  YEARLY: "yearly",
});
